import React, { useState } from 'react';
import { saveLead } from '../data/leads';

// Mr. Ahmed's WhatsApp number — international format, no + or spaces
const AHMED_WHATSAPP = '201008182425';

export default function LeadCapture({ onClose, trialType }) {
  const [name,    setName]    = useState('');
  const [contact, setContact] = useState('');

  function handleSend() {
    const nameStr    = name.trim() || 'A student';
    const contactStr = contact.trim();
    if (contactStr) saveLead(contactStr);

    const typeLabel = trialType === 'test'
      ? 'Test Mode (exam simulation)'
      : 'Smart Writing Mode (guided practice)';

    const message = encodeURIComponent(
      `Hello Mr. Ahmed Salem,\n\nMy name is ${nameStr}${contactStr ? ` and my contact is ${contactStr}` : ''}.\n\nI just tried the IELTSCOMPASS platform and used the free trial for ${typeLabel}.\n\nI would like to know more about the course and get access to more practice questions.\n\nPlease get in touch with me. Thank you!`
    );

    const whatsappUrl = `https://wa.me/${AHMED_WHATSAPP}?text=${message}`;
    window.open(whatsappUrl, '_blank');
    onClose();
  }

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(26,42,74,0.65)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'#ffffff', borderRadius:14, maxWidth:440, width:'100%', overflow:'hidden', boxShadow:'0 16px 48px rgba(26,42,74,0.2)' }}>

        {/* Header */}
        <div style={{ background:'#1a2a4a', padding:'18px 22px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:19, fontWeight:700, color:'#ffffff' }}>
            Free Trial Complete
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.5)', cursor:'pointer', fontSize:20, lineHeight:1 }}>×</button>
        </div>

        {/* Body */}
        <div style={{ padding:'22px 22px 18px' }}>
          <div style={{ fontSize:13.5, color:'#3a4a66', lineHeight:1.75, marginBottom:18 }}>
            You have used your <strong style={{color:'#1a2a4a'}}>free trial</strong>. To access more questions and continue improving your IELTS score, contact <strong style={{color:'#1a2a4a'}}>Mr. Ahmed Salem</strong> on WhatsApp.
          </div>

          {/* Name */}
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.14em', textTransform:'uppercase', color:'#9aa3b8', marginBottom:5 }}>Your Name</div>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="Your name"
            style={{ width:'100%', background:'#f7f9fc', border:'1px solid #dde3ed', borderRadius:8, padding:'10px 13px', color:'#1a2233', fontSize:13.5, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none', marginBottom:12 }}/>

          {/* Contact */}
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.14em', textTransform:'uppercase', color:'#9aa3b8', marginBottom:5 }}>Your WhatsApp Number or Email (optional)</div>
          <input value={contact} onChange={e=>setContact(e.target.value)}
            placeholder="+20 100 000 0000 or name@email.com"
            style={{ width:'100%', background:'#f7f9fc', border:'1px solid #dde3ed', borderRadius:8, padding:'10px 13px', color:'#1a2233', fontSize:13.5, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none', marginBottom:16 }}/>

          {/* Preview of message */}
          <div style={{ background:'#f0faf4', border:'1px solid #c8ead8', borderRadius:8, padding:'11px 14px', marginBottom:16, fontSize:12, color:'#2a4a3a', lineHeight:1.65 }}>
            <div style={{ fontWeight:600, marginBottom:4, color:'#1a7a4a' }}>📲 Message that will be sent to Mr. Ahmed:</div>
            <div style={{ fontStyle:'italic', color:'#3a5a4a' }}>
              "Hello Mr. Ahmed Salem, my name is {name.trim()||'[your name]'}. I just tried the IELTSCOMPASS platform and would like to know more about the course and get access to more practice questions."
            </div>
          </div>

          {/* WhatsApp button */}
          <button onClick={handleSend}
            style={{ width:'100%', background:'#25d366', color:'#ffffff', border:'none', padding:'13px', borderRadius:8, fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", marginBottom:8, display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.522 3.66 1.438 5.168L2 22l4.978-1.301A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18c-1.72 0-3.328-.463-4.717-1.268l-.338-.201-3.508.917.936-3.417-.221-.352A7.944 7.944 0 014 12c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"/></svg>
            Send WhatsApp Message to Mr. Ahmed Salem
          </button>

          <button onClick={onClose}
            style={{ width:'100%', background:'transparent', border:'none', color:'#9aa3b8', padding:'8px', fontSize:12.5, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
            No thanks, continue browsing
          </button>
        </div>
      </div>
    </div>
  );
}
